import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Icon, Link, Modal } from '@phishtool/ui';
import { legalDocuments } from '@phishtool/legal-documents';
import dataProcessingAddendumCoverNote from '@phishtool/legal-documents/build/pdf/data-processing-addendum-cover-note.pdf';
import dataProcessingAgreement from '@phishtool/legal-documents/build/pdf/data-processing-agreement.pdf';
import privacyPolicy from '@phishtool/legal-documents/build/pdf/privacy-policy.pdf';
import proofOfValueAgreement from '@phishtool/legal-documents/build/pdf/proof-of-value-agreement.pdf';
import securityAndComplianceOverview from '@phishtool/legal-documents/build/pdf/security-and-compliance-overview.pdf';
import serviceAgreement from '@phishtool/legal-documents/build/pdf/service-agreement.pdf';
import termsOfService from '@phishtool/legal-documents/build/pdf/terms-of-service.pdf';
import { StyledDownloadList, StyledDownloadListItem, StyledQuoteButton } from './styled';
// Generated from the markdown by @phishtool/legal-documents' build
const complianceDocumentUrls = {
    'data-processing-addendum-cover-note': dataProcessingAddendumCoverNote,
    'data-processing-agreement': dataProcessingAgreement,
    'privacy-policy': privacyPolicy,
    'proof-of-value-agreement': proofOfValueAgreement,
    'security-and-compliance-overview': securityAndComplianceOverview,
    'service-agreement': serviceAgreement,
    'terms-of-service': termsOfService,
};
const complianceDocuments = Object.entries(complianceDocumentUrls).map(([id, url]) => ({
    label: `${legalDocuments[id].title}.pdf`,
    url,
}));
const ComplianceDocuments = () => {
    const [isOpen, setIsOpen] = useState(false);
    const closeModal = () => setIsOpen(false);
    return (_jsxs(_Fragment, { children: [_jsxs(StyledQuoteButton, { href: "#", onClick: (e) => {
                    e.preventDefault();
                    setIsOpen(true);
                }, children: [_jsx("span", { children: "Compliance documents" }), _jsx(Icon, { name: "document", size: { width: 52, height: 36 }, alignment: "vertical" })] }), _jsx(Modal, { isOpen: isOpen, closeModal: closeModal, heading: "Compliance documents", headingSize: "large", size: "small", children: _jsx(StyledDownloadList, { children: complianceDocuments.map((complianceDocument) => (_jsx(StyledDownloadListItem, { children: _jsx(Link, { color: "burntOrange", to: complianceDocument.url, download: complianceDocument.label, downloadIcon: true, children: complianceDocument.label }) }, complianceDocument.url))) }) })] }));
};
export default ComplianceDocuments;
